import { z } from "zod";
import {
  HerSkinRunIdSchema,
  HerSkinSessionIdSchema,
  IsoDateTimeSchema,
  StableIdSchema,
} from "./common.js";

export const NotificationKindSchema = z.enum([
  "run_completed",
  "run_failed",
  "action_required",
  "cron_completed",
  "cron_failed",
]);

export const NotificationTargetSchema = z.discriminatedUnion("workspace", [
  z
    .object({
      workspace: z.literal("chat"),
      sessionId: HerSkinSessionIdSchema,
      runId: HerSkinRunIdSchema,
    })
    .strict(),
  z
    .object({
      workspace: z.literal("cron"),
      jobId: StableIdSchema,
    })
    .strict(),
]);

export const NotificationItemSchema = z
  .object({
    notificationId: StableIdSchema,
    /** 用于单设备浏览器通知去重；Cron 投影没有实时事件时为 null。 */
    sourceEventId: StableIdSchema.nullable(),
    kind: NotificationKindSchema,
    title: z.string().min(1).max(160),
    detail: z.string().min(1).max(240),
    target: NotificationTargetSchema,
    createdAt: IsoDateTimeSchema,
    readAt: IsoDateTimeSchema.nullable(),
  })
  .strict();

export const NotificationListSchema = z
  .object({
    items: z.array(NotificationItemSchema).max(100),
    unreadCount: z.number().int().nonnegative(),
    updatedAt: IsoDateTimeSchema,
  })
  .strict();

export const NotificationMutationResponseSchema = z
  .object({
    updated: z.number().int().nonnegative(),
    updatedAt: IsoDateTimeSchema,
  })
  .strict();

export type NotificationKind = z.infer<typeof NotificationKindSchema>;
export type NotificationTarget = z.infer<typeof NotificationTargetSchema>;
export type NotificationItem = z.infer<typeof NotificationItemSchema>;
export type NotificationList = z.infer<typeof NotificationListSchema>;
export type NotificationMutationResponse = z.infer<typeof NotificationMutationResponseSchema>;
